var map = {
	".": 86,
	"./": 86,
	"./ActivateSelection": 140,
	"./ActivateSelection.js": 140,
	"./App": 102,
	"./App.css": 235,
	"./App.js": 102,
	"./App.test": 250,
	"./App.test.js": 250,
	"./CMoreActivate": 174,
	"./CMoreActivate.js": 174,
	"./DisneyplayActivate": 141,
	"./DisneyplayActivate.js": 141,
	"./DplayActivate": 103,
	"./DplayActivate.css": 29,
	"./DplayActivate.js": 103,
	"./ParamountActivate": 173,
	"./ParamountActivate.js": 173,
	"./PodmeActivate": 142,
	"./PodmeActivate.js": 142,
	"./ReadlyActivate": 143,
	"./ReadlyActivate.js": 143,
	"./Rejected": 144,
	"./Rejected.js": 144,
	"./SappaPlayActivateTv": 145,
	"./SappaPlayActivateTv.js": 145,
	"./SkyShowTimeActication": 76,
	"./SkyShowTimeActication.js": 76,
	"./SkyShowtimeActivate": 138,
	"./SkyShowtimeActivate.js": 138,
	"./SkyShowtimeTest": 139,
	"./SkyShowtimeTest.js": 139,
	"./TV4PlayActivate": 104,
	"./TV4PlayActivate.js": 104,
	"./ThreeDots": 13,
	"./ThreeDots.js": 13,
	"./ViaplayActivate": 137,
	"./ViaplayActivate.js": 137,
	"./ViaplayActivateBitcom": 146,
	"./ViaplayActivateBitcom.js": 146,
	"./images/CMoreLogoNew.jpg": 249,
	"./images/Paramount_Plus.png": 248,
	"./images/SappaPatternGreen.jpg": 669,
	"./images/SappaPlay.png": 670,
	"./images/Sappa_Green.png": 33,
	"./images/Sappa_Play_Green.png": 291,
	"./images/Selection_Podme.png": 671,
	"./images/Selection_Readly.png": 672,
	"./images/SkyShowtimeSelection.png": 290,
	"./images/ViaplayLogo.jpg": 172,
	"./images/bitcom_logo.png": 293,
	"./images/dplay.png": 237,
	"./images/dplus.png": 247,
	"./images/logo.svg": 673,
	"./images/podme_background.png": 153,
	"./images/readly_background.jpg": 154,
	"./images/sappa_background.jpg": 155,
	"./images/sappa_logo.png": 236,
	"./images/selection_discoveryplus.png": 674,
	"./images/selection_disneyplus.png": 289,
	"./images/selection_paramountplus.png": 675,
	"./images/selection_viaplay.png": 676,
	"./images/showtimemain.jpg": 148,
	"./images/skyshowtimebackground.jpg": 677,
	"./images/streamingbackground.png": 678,
	"./images/tv4play.jpg": 292,
	"./index": 86,
	"./index.css": 234,
	"./index.js": 86,
	"./serviceWorker": 136,
	"./serviceWorker.js": 136,
	"./setupTests": 294,
	"./setupTests.js": 294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 417;